import Loading from '@Web/Src/UI/Loading';
import SectionHeader from '@Web/Src/Components/SectionHeader';

const FlagsLazy = ({ title = __('Build referral  programs in over 20 languages') }) => {
    return (
        <>
            <SectionHeader
                type='dark'
                className='mt-44'
                icon='globe'
                title={title}
                desc={__('')}
            />
            <div className='swiper-mask mt-10 flex w-full max-w-4xl justify-center'>
                <Loading type={'ellipsis'} />
            </div>
        </>
    );
};

export default FlagsLazy;
